var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayStoreUncolored = function SvgPlayStoreUncolored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.829 2.34c.307-.042.619.029.881.2l8.952 5.27-2.265 2.375zm-.689.713a1.7 1.7 0 0 0-.062.478v14.736q-.002.243.062.477l7.575-7.845zm8.264 8.559-7.575 7.846c.307.045.62-.026.881-.2l8.952-5.27zm5.867-1.67-2.713-1.597-2.48 2.554 2.473 2.56 2.713-1.597c.895-.528.895-1.398 0-1.926z"
  })));
};
export default SvgPlayStoreUncolored;